const financeElement = document.querySelector('.finance-disclaimer');
const financeBtn = document.querySelector('.finance-disclaimer__btn');

if (financeElement && financeBtn) {
  financeBtn.addEventListener('click', () => financeElement.classList.toggle('finance-disclaimer--open'));
}